import PropTypes from 'prop-types';
import React from 'react';
import SecondaryNav from '../../Common/containers/SecondaryNav';

function BoxingNav({open, opener}) {
  const props = {
    open,
    opener,
    title: "Boxing",
    links: [
      {href: "/boxing", text: "News", isIndex: true}
    ]
  };

  return (
    <SecondaryNav {...props}/>
  );
}

BoxingNav.propTypes = {
  open: PropTypes.bool.isRequired,
  opener: PropTypes.func.isRequired
}

export default BoxingNav



// WEBPACK FOOTER //
// ./modules/Boxing/nav/BoxingNav.js